module.exports = __webpack_public_path__ + "static/media/ROCKWOOL_logo_neg.7c02e998.svg";